// extracted by mini-css-extract-plugin
export default {"screen-content":"AdministrationRolesScreen_screen-content__SCjre","table":"AdministrationRolesScreen_table__qQSW0"};